import type { Investigation } from '@/types/data'

const links = {
  prep: {
    share: 'https://e-surgery.com/prep-test-kit-understanding-your-results',
    retest: 'https://e-surgery.com/product/prep-test-kit'
  },
  chlamydia: {
    share: 'https://e-surgery.com/understanding-your-chlamydia-gonorrhoea-test-results',
    retest: 'https://e-surgery.com/product/chlamydia-and-gonorrhoea-test-kit'
  }
} as const

export const getInvestigationLink = (investigation: Investigation) => {
  const name = investigation.name.toLowerCase()
  const type = Object.keys(links).find(key => name.includes(key))

  if (type) {
    return links[type as keyof typeof links]
  }

  throw new Error(`No matching investigation type found for "${investigation.name}"`)
}
